(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uni-brand-directory"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('uni-brand-directory')) {
    customElements.define('uni-brand-directory', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const input = this.querySelector('input[type="search"]');
        const entries = [...this.querySelectorAll('[data-brand]')];
        const groups = [...this.querySelectorAll('[data-group]')];
        const status = this.querySelector('[data-status]');
        const normalize = value => value.normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase().trim();
        const update = () => {
          const term = normalize(input.value);
          let count = 0;
          entries.forEach(entry => { entry.hidden = !normalize(entry.dataset.brand).includes(term); if (!entry.hidden) count++; });
          groups.forEach(group => {
            group.hidden = ![...group.querySelectorAll('[data-brand]')].some(entry => !entry.hidden);
            const letter = this.querySelector('[data-letter="' + group.dataset.group + '"]');
            if (letter) letter.hidden = group.hidden;
          });
          status.textContent = status.dataset.template.replace('__COUNT__', String(count));
          this.querySelector('[data-empty]').hidden = count !== 0;
        };
        input.addEventListener('input', update);
        this.querySelector('[data-clear]').addEventListener('click', () => { input.value = ''; update(); input.focus(); });
        this.querySelector('[data-search-panel]').hidden = false;
        update();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uni-package-tracking"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('uni-package-tracker')) {
    customElements.define('uni-package-tracker', class extends HTMLElement {
      connectedCallback() {
        const form = this.querySelector('form');
        if (!form || form.dataset.ready) return;
        form.dataset.ready = 'true';
        form.hidden = false;
        form.addEventListener('submit', (event) => {
          event.preventDefault();
          const number = form.elements.nums.value.replace(/\s+/g, '');
          if (!number) return;
          const destination = new URL(form.action);
          destination.hash = 'nums=' + encodeURIComponent(number);
          window.open(destination.toString(), '_blank', 'noopener,noreferrer');
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uni-promo-strip"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('uni-promo-strip')) {
    customElements.define('uni-promo-strip', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.offers = [...this.querySelectorAll('[data-offer]')];
        this.pauseButton = this.querySelector('[data-pause]');
        this.media = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.index = 0;
        this.paused = false;
        this.hovered = false;
        this.focused = false;
        this.animating = false;
        this.rotationDelay = Math.max(5000, Number(this.dataset.rotationSeconds || 5) * 1000);
        this.querySelector('[data-promo-controls]').hidden = false;
        this.pauseButton.addEventListener('click', () => {
          this.paused = !this.paused;
          this.updatePauseControl();
          this.scheduleRotation();
        }, { signal });
        this.querySelector('[data-next]').addEventListener('click', () => this.nextOffer(), { signal });
        this.addEventListener('pointerenter', event => {
          if (event.pointerType === 'touch') return;
          this.hovered = true;
          this.scheduleRotation();
        }, { signal });
        this.addEventListener('pointerleave', () => {
          this.hovered = false;
          this.scheduleRotation();
        }, { signal });
        this.addEventListener('focusin', () => {
          this.focused = true;
          this.scheduleRotation();
        }, { signal });
        this.addEventListener('focusout', () => {
          queueMicrotask(() => {
            this.focused = this.contains(document.activeElement);
            this.scheduleRotation();
          });
        }, { signal });
        this.media.addEventListener('change', () => {
          this.updatePauseControl();
          this.scheduleRotation();
        }, { signal });
        document.addEventListener('visibilitychange', () => this.scheduleRotation(), { signal });
        this.updatePauseControl();
        this.scheduleRotation();
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        clearTimeout(this.rotationTimer);
        this.animations?.forEach(animation => animation.cancel());
      }

      updatePauseControl() {
        this.pauseButton.hidden = this.media.matches;
        this.pauseButton.setAttribute('aria-label', this.paused ? this.dataset.resumeLabel : this.dataset.pauseLabel);
        this.querySelector('[data-pause-icon]').hidden = this.paused;
        this.querySelector('[data-play-icon]').hidden = !this.paused;
      }

      scheduleRotation() {
        clearTimeout(this.rotationTimer);
        if (!this.isConnected || this.paused || this.hovered || this.focused || this.media.matches || document.hidden) return;
        this.rotationTimer = setTimeout(() => this.nextOffer(), this.rotationDelay);
      }

      async nextOffer() {
        if (this.animating) return;
        clearTimeout(this.rotationTimer);
        const previous = this.offers[this.index];
        this.index = (this.index + 1) % this.offers.length;
        const next = this.offers[this.index];
        previous.setAttribute('aria-hidden', 'true');
        previous.tabIndex = -1;
        previous.inert = true;
        next.hidden = false;
        next.removeAttribute('aria-hidden');
        next.removeAttribute('tabindex');
        next.inert = false;
        if (!this.media.matches && typeof next.animate === 'function') {
          this.animating = true;
          const options = { duration: 280, easing: 'cubic-bezier(.22,.61,.36,1)' };
          this.animations = [
            previous.animate([{ transform: 'translateY(0)' }, { transform: 'translateY(-100%)' }], options),
            next.animate([{ transform: 'translateY(100%)' }, { transform: 'translateY(0)' }], options)
          ];
          await Promise.allSettled(this.animations.map(animation => animation.finished));
          this.animating = false;
        }
        previous.hidden = true;
        this.scheduleRotation();
      }

    });
  }

  } catch(e) { console.error(e); }
})();
})();
